import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'react-bootstrap';
import {
	isEqual, isUndefined, map, cloneDeep, set, get, find, isEmpty,
} from 'lodash';
import { Loader } from '@components/common';
import constants from '@constants';
import MapView from '@components/JobsMap/MapView';
import MapSidebar from '@components/JobsMap/MapSidebar';
import JobsListItem from '@components/JobsMap/JobsListItem';
import { thunks } from '@redux/jobs';
import JobsWrapper from './components/jobsWrapper';
import Header from './components/header';

class MapPage extends JobsWrapper {
	constructor(props) {
		super(props);
		const {
			jobs,
			activeJob,
		} = props;

		const coordinates = this.getJobsCoordinates(jobs);
		const center = this.getCenterFromJob(activeJob, jobs);

		this.state = {
			coordinates,
			center,
		};
	}

	componentDidMount = () => this.componentDidMountAddOn()

	UNSAFE_componentWillReceiveProps = (nextProps) => {
		const { jobs, activeJob } = nextProps;
		const lastProps = this.props;
		const newState = cloneDeep(this.state);

		// Run UNSAFE_componentWillReceivePropsAddOn
		this.UNSAFE_componentWillReceivePropsAddOn(nextProps);

		// Update coordinates
		if (!isEqual(jobs, lastProps.jobs)) set(newState, ['coordinates'], this.getJobsCoordinates(jobs));

		// Update mapCenter
		if (
			!isEqual(activeJob, lastProps.activeJob)
			|| !isEqual(jobs, lastProps.jobs)
		) set(newState, ['center'], this.getCenterFromJob(activeJob, jobs));

		this.setState(newState);
	}

	shouldComponentUpdate = ({
		jobs,
		activeJob,
		totalCount,
		loading,
		loadingPoints,
		filter,
	}, {
		center,
		coordinates,
	}) => {
		const lastProps = this.props;
		const lastState = this.state;

		return (
			!isEqual(jobs, lastProps.jobs)
			|| !isEqual(activeJob, lastProps.activeJob)
			|| !isEqual(totalCount, lastProps.totalCount)
			|| !isEqual(loading, lastProps.loading)
			|| !isEqual(loadingPoints, lastProps.loadingPoints)
			|| !isEqual(filter, lastProps.filter)
			|| !isEqual(center, lastState.center)
			|| !isEqual(coordinates, lastState.coordinates)
		);
	}

	getJobsCoordinates = (jobs) => (map(jobs, ({
		LocationAddress,
		LocationCityStateZip,
		OfficerStatus,
		Id : id,
		LocationLatitude : lat,
		LocationLongitude : lng,
		ClientName : title,
	}) => {
		const officerStatusConstant = find(constants.OFFICER_STATUSES, ['type', OfficerStatus || 0]) || constants.OFFICER_STATUSES.none;

		return {
			id,
			lat,
			lng,
			title,
			message : `${LocationAddress}, ${LocationCityStateZip}`,
			color   : officerStatusConstant.color,
			status  : OfficerStatus,
		};
	}))

	getCenterFromJob = (jobId, jobs) => {
		const job = find(jobs, ['Id', jobId]);

		/**
		 * If job wasn't found
		 * we don't have to create
		 * anything
		 */
		if (isUndefined(job)) return undefined;

		return {
			lat : get(job, ['LocationLatitude']),
			lng : get(job, ['LocationLongitude']),
		};
	}

	handleOnPaginate = (direction, event) => {
		event.preventDefault();

		const {
			applyCriteria,
			totalCount,
			filter : {
				displayCount,
				pageNumber,
			},
		} = this.props;
		const property = 'pageNumber';
		const value = direction === 'prev' ? pageNumber - 1 : pageNumber + 1;
		const totalPages = Math.ceil(totalCount / displayCount);

		if (
			(direction === 'prev' && pageNumber === 1)
			|| (direction === 'next' && pageNumber === totalPages)
		) return;

		applyCriteria([{ property, value }]);
	}

	updateActiveJob = (jobId) => this.props.applyCriteria([{ property : 'jobId', value : jobId }])

	render() {
		const {
			timeZone,
			jobs,
			totalCount,
			loading,
			activeJob,
			filter : {
				displayCount,
				pageNumber,
			},
		} = this.props;
		const {
			coordinates,
			center,
		} = this.state;
		const isActiveJob = activeJob !== '';

		return (
			<React.Fragment>
				<Header
					hideDeleteButton
					pageName="Map View"
				/>
				<Grid className="container-wide jobs-map margin-top-10">
					<div className="map-container">
						<MapView
							jobs={coordinates}
							zoom={isActiveJob ? 15 : undefined}
							center={isActiveJob ? center : undefined}
							timeZoneId={timeZone}
						/>
						<MapSidebar
							pageNumber={pageNumber}
							totalCount={totalCount}
							displayCount={displayCount}
							loading={loading}
							isEmptyList={isEmpty(jobs)}
							handleOnPaginate={this.handleOnPaginate}
						>
							<For
								each="job"
								of={jobs}
							>
								<JobsListItem
									key={`job_${job.Id}`}
									job={job}
									ref={job.Id === activeJob ? 'activeItem' : undefined}
									active={job.Id === activeJob}
									onClick={this.updateActiveJob}
									timeZoneId={timeZone}
								/>
							</For>
						</MapSidebar>
					</div>
					<Loader active={loading} />
				</Grid>
			</React.Fragment>
		);
	}
}

const mapStateToProps = ({
	app: { user : { TimeZoneId : timeZone } },
	jobs : {
		jobs,
		totalCount,
		activeMapJob : activeJob,
		loaders : {
			jobs : loading,
		},
		filter : {
			displayCount,
			pageNumber,
		},
	},
}) => ({
	timeZone,
	jobs,
	activeJob,
	totalCount,
	loading,
	filter : {
		displayCount,
		pageNumber,
	},
});

const mapDispatchToProps = (dispatch) => ({
	processUrl    : bindActionCreators(thunks, dispatch).processUrl,
	applyCriteria : bindActionCreators(thunks, dispatch).applyCriteria,
});

export default connect(mapStateToProps, mapDispatchToProps)(MapPage);
